import { render, staticRenderFns } from "./JalekoRecomendaCarousel.vue?vue&type=template&id=77d50da0&scoped=true&"
import script from "./JalekoRecomendaCarousel.vue?vue&type=script&lang=js&"
export * from "./JalekoRecomendaCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d50da0",
  null
  
)

export default component.exports